
import { defineComponent } from 'vue';
import { Field, FieldBig } from './charts';
import numeral from 'numeral';

export default defineComponent({
  name: 'StaffDeskTop',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    visitData: {
      type: [Array, Object],
      required: true,
    },
  },
  setup(props: any) {
    console.log('props', props.visitData);
    return {
      numeral,
    };
  },
  components: {
    Field,
    FieldBig,
  },
});
